import { render, staticRenderFns } from "./declare2.vue?vue&type=template&id=4c8321b1&scoped=true&"
import script from "./declare2.vue?vue&type=script&lang=js&"
export * from "./declare2.vue?vue&type=script&lang=js&"
import style0 from "./declare2.vue?vue&type=style&index=0&id=4c8321b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8321b1",
  null
  
)

export default component.exports